import Badge from './badge'
import { BadgeSizes, BadgeTypes } from './constants'

export { BadgeSizes, BadgeTypes }

export default Badge
